import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';

import { FormSubFormDirective } from './@directives';
import { MwFormActionsComponent } from './form-actions';
import { MwFormNavigationComponent } from './form-navigation';
import { MwFormSectionComponent } from './form-section';
import { MwFormSectionTitleComponent } from './form-section-title';
import { MwFormSidebarComponent } from './form-sidebar';
import { MwFormTitleComponent } from './form-title';
import { MwFormWidgetComponent } from './form-widget';
import { MwFormComponent } from './form.component';
import { MwDirectivesModule } from '@core/directives/directives.module';
import { MwArrowTogglerModule } from '../arrow-toggler/arrow-toggler.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatIconModule,
    MwArrowTogglerModule,
    MwDirectivesModule,
  ],
  exports: [
    MwFormSectionComponent,
    MwFormWidgetComponent,
    MwFormActionsComponent,
    MwFormComponent,
    FormSubFormDirective,
  ],
  declarations: [
    MwFormNavigationComponent,
    MwFormTitleComponent,
    MwFormSectionComponent,
    MwFormSectionTitleComponent,
    MwFormSidebarComponent,
    MwFormWidgetComponent,
    MwFormActionsComponent,
    MwFormComponent,
    FormSubFormDirective,
  ],
  providers: [],
})
export class MwFormModule {}
